import React from 'react';
import { FileText, Target, ChevronRight, BarChart3 } from 'lucide-react';

const Supporting = () => (
  <div className="space-y-8">
    <h2 className="text-3xl font-bold text-gray-900">Supporting Materials</h2>
    
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <div className="bg-white p-8 rounded-xl border shadow-sm">
        <h3 className="text-xl font-semibold mb-6 flex items-center space-x-2">
          <FileText className="w-5 h-5 text-blue-600" />
          <span>Documents</span>
        </h3>
        <div className="space-y-4">
          <div className="flex items-center justify-between p-4 rounded-lg hover:bg-blue-50 cursor-pointer border hover:border-blue-200 transition-all">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                <FileText className="w-5 h-5 text-red-600" />
              </div>
              <div>
                <div className="text-sm font-medium text-gray-900">Sample Document - Not Downloadable</div>
                <div className="text-xs text-gray-500">PDF • 4.1 MB • Updated Dec 1, 2025</div>
              </div>
            </div>
            <ChevronRight className="w-4 h-4 text-blue-600" />
          </div>
        </div>
      </div>

      <div className="bg-white p-8 rounded-xl border shadow-sm">
        <h3 className="text-xl font-semibold mb-6 flex items-center space-x-2">
          <Target className="w-5 h-5 text-purple-600" />
          <span>Interactive Tools</span>
        </h3>
        <div className="space-y-4">
          <div className="flex items-center justify-between p-4 rounded-lg hover:bg-gray-50 cursor-pointer border hover:border-gray-300 transition-all">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                <BarChart3 className="w-5 h-5 text-purple-600" />
              </div>
              <div>
                <div className="text-sm font-medium text-gray-900">Sample Artifact - Not Active</div>
                <div className="text-xs text-gray-500">Claude Artifact • Updated for October 2025</div>
              </div>
            </div>
            <ChevronRight className="w-4 h-4 text-purple-600" />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Supporting;